import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import FractionDisplay from "./FractionDisplay";

export default class CombineContainer extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);

        this.deletegate = scene;

        this.correctFraction1 = null;
        this.correctFraction2 = null;

        this.effect = null;
        this.one = null;

        this.oneTarget = null;

        this.correctFraction1 = new FractionDisplay(this.scene).setVisible(false);
        this.correctFraction2 = new FractionDisplay(this.scene).setVisible(false);

        this.effect = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, "EffectAnimations/0").setVisible(false);
        this.one = ABCyaPhaser.Images.addImage(0, 0, "YellowOne", this).setVisible(false);
        this.oneTarget = { x: 0, y: 0 };

        this.add([this.correctFraction1, this.correctFraction2, this.effect, this.one]);
    }

    startCombine(st, loc)
    {
        this.oneTarget = loc;
        let pt1 = st[0].getGlobalFractionLoc();
        let pt2 = st[1].getGlobalFractionLoc();

        this.correctFraction1.reset(st[0].fractionValue);
        this.correctFraction1.x = pt1.x;
        this.correctFraction1.y = pt1.y;
        this.correctFraction1.alpha = 1;

        this.correctFraction2.reset(st[1].fractionValue);
        this.correctFraction2.x = pt2.x;
        this.correctFraction2.y = pt2.y;
        this.correctFraction2.alpha = 1;

        this.correctFraction1.setVisible(true);
        this.correctFraction2.setVisible(true);

        let middle = { x: (pt1.x + pt2.x) / 2, y: (pt1.y + pt2.y) / 2 };
        ABCyaPhaser.Tweens.addTween([this.correctFraction1, this.correctFraction2], 800, { x: middle.x, y: middle.y }, Phaser.Math.Easing.Linear, () => this.showOneEffect());
    }

    showOneEffect()
    {
        // tint all children
        this.correctFraction1.colorFraction(0xf4e42a);
        this.correctFraction2.colorFraction(0xf4e42a);

        this.one.setTintFill(0xf4e42a).setVisible(true);
        this.one.x = this.correctFraction1.x + 6;
        this.one.y = this.correctFraction1.y + 6;
        this.one.alpha = 0;

        ABCyaPhaser.Tweens.addTween([this.correctFraction1, this.correctFraction2], 800, { alpha: 0 }, Phaser.Math.Easing.Linear);
        this.scene.time.delayedCall(600, () =>
        {
            this.showFlash();
            ABCyaPhaser.Tweens.addTween(this.one, 800, { alpha: 1 }, Phaser.Math.Easing.Linear, () => this.passOffOne());
        });
    }

    showFlash()
    {
        let num = Phaser.Math.Between(1, 4);
        let xo = 0;
        let yo = 0;
        let snum = 2;
        switch (num)
        {
            case 1:
                xo = -10;
                yo = -3;
                break;

            case 2:
                xo = 0;
                yo = 10;
                break;

            case 3:
                snum = 1;
                xo = -8;
                yo = -8;
                break;

            case 4:
                xo = 0;
                yo = -20;
                break;
        }
        ABCyaPhaser.Audio.playOneShot("effect" + snum, this.scene);
        this.effect.play("effect" + num);
        this.effect.x = this.correctFraction1.x - 50 + xo;
        this.effect.y = this.correctFraction1.y - 50 + yo;
        this.effect.setVisible(true);
        this.effect.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => this.effect.setVisible(false));
    }

    passOffOne()
    {
        ABCyaPhaser.Tweens.addTween(this.one, 800, { x: this.oneTarget.x - this.one.width / 2, y: this.oneTarget.y - this.one.height }, Phaser.Math.Easing.Linear, () => this.readyToEat());
    }

    readyToEat()
    {
        this.one.setVisible(false);
        this.deletegate.feedMonster();
    }
}